import _ from "lodash";

export default class ValidationErrorHandler {
    #$errors
    #$errorsList = []
    #$htmlContent
    #$massageTitle = 'لطفا خطا های به وجود آمده را برطرف نمایید: '

    constructor($errors) {
        this.#$errors = $errors;
        this.#flatErrors()
    }

    #flatErrors() {
        if (_.isObject(this.#$errors)) {
            for (const error in this.#$errors) {
                this.#$errors[error].forEach((item) => {
                    this.#$errorsList.push(item)
                })
            }
        }
    }
    
    static create($errors) {
        return new ValidationErrorHandler($errors)
    }

    toHtml() {
        let errorItems = '';
        for (const error of this.toArray()) {
            errorItems = errorItems.concat(`<li class="error-item">${error}</li>`)
        }

        this.#$htmlContent = `<div class="validation-errors-wrapper"><ul class="validation-errors">${errorItems}</ul></div>`
        return this
    }

    get() {
        if (_.isUndefined(this.#$htmlContent)) {
            return this.toArray()
        }
        return `<div class="alert alert-danger text-right">
                    <h6 class="alert-heading font-size-base font-weight-bolder">${this.#$massageTitle}</h6>
                    <div class="alert-text font-size-sm">
                        ${this.#$htmlContent}
                    </div>
                </div>`
    }

    toArray() {
        return this.#$errorsList;
    }
}